import $ from 'jquery';
import headerWidget from '../../Widgets/header';

function initHeader() {
  const $header = $('#oc-header');

  if ($header.length) {
    headerWidget.create($header);
  }
}

export default {
  init: initHeader,
};
